
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "getBrandsForDefaultPipes",
      resolverType: "query",
      routePath: "/getBrandsForDefaultPipes",
      httpMethod: "POST",
    });
  